












import { defineComponent, onMounted } from '@vue/composition-api';
import ProfileCover from '@/ui/components/profile/ProfileCover.vue';
import ProfileMenu from '@/ui/components/profile/ProfileMenu.vue';
import HProfileCard from '@/ui/components/base/HProfileCard.vue';

import useProfileVariables from '@/ui/composables/profile/use-profile-variables';
import useProfileFunctions from '@/ui/composables/profile/use-profile-functions';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Profile',
  components: {
    ProfileCover,
    ProfileMenu,
    HProfileCard,
  },
  computed: {
    ...mapGetters({
      user: 'profile/profile',
    }),
  },
  setup(_, { root }) {
    const route = root.$route;
    const profileVariables = useProfileVariables();
    const { loadUser } = useProfileFunctions(root.$store, profileVariables);

    onMounted(async () => {
      await loadUser(route.params.id);
    });
  },
});
